"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");


















































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      deviceTypelist: [], versionList: [], title: '', newadd: false, addData: { id: '', deviceTypeId: '', otaVersionId: '', limitOtaVersionId: '', type: 2, rangeList: [] }, defaultData: { id: '', deviceTypeId: '', otaVersionId: '', limitOtaVersionId: '', type: 2, rangeList: [] }, searchData: { // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'deviceType', label: '设备类型', isShow: true }, { prop: 'limitOtaVersion', label: '中心板版本', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], rules: { content: [{ required: true, message: '请输入更新内容', trigger: 'blur' }], locale: [{ required: true, message: '请选择界面语言', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.addData.otaVersionId = self.$route.params.parentId;self.defaultData.otaVersionId = self.$route.params.parentId;self.init();self.dropList();}, methods: { init: function init() {var self = this;self.getData('/api/faOtaVersionLimit/limit/' + self.addData.otaVersionId, self.searchData, function (res) {console.log(res);self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faOtaVersionLimit/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, updateMenu: function updateMenu(item) {this.title = '修改';
      var self = this;
      self.changeBrandIdFun(item.deviceTypeId);
      this.addData = {
        id: item.id,
        deviceTypeId: item.deviceTypeId,
        limitOtaVersionId: item.limitOtaVersionId,
        otaVersionId: self.$route.params.parentId,
        type: 2 };

      self.newadd = true;
    },
    onSubmit: function onSubmit(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.rangeList = [{
            deviceTypeId: self.addData.deviceTypeId,
            limitOtaVersionId: self.addData.limitOtaVersionId }];

          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionLimit/range', self.addData, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionUpdateContent/', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    dropList: function dropList() {
      var self = this;
      self.getData('/api/faDeviceType', {
        rows: 200 },
      function (res) {
        self.deviceTypelist = res.list;
      });
    },
    changeBrandIdFun: function changeBrandIdFun(data) {
      var self = this;
      self.addData.limitOtaVersionId = '';
      var obj = {};
      obj = self.deviceTypelist.find(function (item) {
        return item.id === data;
      });
      self.addData.deviceTypeId = obj.id;
      self.getData('/api/faOtaVersion/' + self.addData.deviceTypeId + '/list', {}, function (res) {
        self.versionList = res;
      });
    },
    onCencal: function onCencal() {
      this.$refs.addForm.resetFields();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.$refs['addForm'].resetFields();
      this.newadd = false;
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/voice/voiceEdition');
    } } };exports.default = _default;